import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { QRCodeModule } from 'angularx-qrcode';
import { MatDialogModule } from '@angular/material/dialog';

import { CoreUiModule } from '../core-ui/core-ui.module';
import { TicketActions } from './actions/ticket.actions';
import { BaseTicketComponent } from './components/base-ticket/base-ticket.component';
import { GroupedTicketsBodyComponent } from './components/grouped-tickets-body/grouped-tickets-body.component';
import { GroupedTicketsHeaderComponent } from './components/grouped-tickets-header/grouped-tickets-header.component';
import { GroupedTicketsComponent } from './components/grouped-tickets/grouped-tickets.component';
import { HoursTicketComponent } from './components/hours-ticket/hours-ticket.component';
import { PeriodTicketComponent } from './components/period-ticket/period-ticket.component';
import { SingleTicketComponent } from './components/single-ticket/single-ticket.component';
import { TicketActionsDropdownComponent } from './components/ticket-actions-dropdown/ticket-actions-dropdown.component';
import { TicketSummaryV2Component } from './components/ticket-summary-v2/ticket-summary-v2.component';
import { TicketSummaryComponent } from './components/ticket-summary/ticket-summary.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { TripMessageComponent } from './components/trip-message/trip-message.component';
import { WalletTicketSummaryV2Component } from './components/wallet-ticket-summary-v2/wallet-ticket-summary-v2.component';
import { WalletTicketComponent } from './components/wallet-ticket/wallet-ticket.component';
import { TicketDeviceGuard } from './guards/ticket-device.guard';
import { TicketFocusService } from './ticket-focus.service';
import { TicketsService } from './tickets.service';
@NgModule({
    imports: [CommonModule, CoreModule, CoreUiModule, TranslateModule, QRCodeModule, MatDialogModule],
    declarations: [
        TicketSummaryComponent,
        TicketSummaryV2Component,
        WalletTicketSummaryV2Component,
        TicketComponent,
        TripMessageComponent,
        BaseTicketComponent,
        PeriodTicketComponent,
        HoursTicketComponent,
        SingleTicketComponent,
        WalletTicketComponent,
        GroupedTicketsComponent,
        GroupedTicketsHeaderComponent,
        GroupedTicketsBodyComponent,
        TicketActionsDropdownComponent
    ],
    providers: [TicketsService, TicketActions, TicketFocusService, TicketDeviceGuard],
    exports: [
        TicketSummaryComponent,
        TicketSummaryV2Component,
        WalletTicketSummaryV2Component,
        TicketComponent,
        TripMessageComponent,
        GroupedTicketsComponent,
        TicketActionsDropdownComponent
    ]
})
export class TicketsModule {}
